import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RouterReference, RouterReferenceEnumMapping, RouterReferenceInterface } from 'src/app/shared/enum/router-reference';

@Component({
  selector: 'app-relead-router',
  templateUrl: './relead-router.component.html'
})
export class ReleadRouterComponent implements OnInit {

  @Input() "form" : FormGroup
  routerReferenceStatus: RouterReferenceInterface[];
  constructor() { }

  ngOnInit(): void {
    this.routerReferenceStatus = Object.keys(RouterReference)
    .filter((value) => isNaN(Number(value)) === true)
    .map((key: string | any) => ({
      id: RouterReference[key as keyof typeof RouterReference],
      value: RouterReferenceEnumMapping[key as keyof typeof RouterReference],
    }));
  }

}
